import { Component } from 'react';
import { Link } from 'react-router-dom';
import withRouter from 'utils/with-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import types from 'utils/prop-types';
import constants from 'utils/constants';
import api from 'utils/api';
import { isEmpty, isBlokurUser, isDndSubscriber } from 'utils/auth';
import Mixpanel from 'utils/mixpanel';
import { fetchUser } from 'ducks/modules/user';
import { pushToast } from 'ducks/modules/toaster';
import Header from 'components/header/header';
import SiteMessage from 'components/site-message/site-message';
import 'components/site-header/site-header.scss';

class SiteHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cookiesOpen: false,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.user !== prevProps.user) {
            this.setState({ cookiesOpen: this.props.user.accepted_cookies === null });
        }
    }

    async submitCookiesForm(response) {
        try {
            this.setState({ cookiesOpen: false });
            if (response) {
                await api.acceptForm('cookies-policy');
                Mixpanel.lib.opt_in_tracking();
            } else {
                await api.rejectForm('cookies-policy');
                Mixpanel.lib.opt_out_tracking();
            }
            await this.props.fetchUser();
            this.props.pushToast({
                title: `You have ${
                    response ? 'accepted' : 'rejected'
                } the cookie policy. You can always change this later.`,
                type: constants.ToastTypes.SUCCESS,
            });
        } catch {
            this.props.pushToast({
                title: 'Oops! Something went wrong there.',
                type: constants.ToastTypes.ERROR,
            });
        }
    }

    render() {
        const result = [];
        if (this.props.publicView || (!isEmpty() && this.props.history.location.pathname.indexOf('/login') === -1)) {
            result.push(
                <SiteMessage
                    key="cookies-policy"
                    isOpen={this.state.cookiesOpen}
                    onClose={() => this.setState({ cookiesOpen: false })}
                    content={
                        <p>
                            Blokur would like to use cookies to ensure you get the best experience. You can find out
                            more in our{' '}
                            <Link to="/documents/cookies-policy" target="_blank">
                                Cookie Policy
                            </Link>
                            .
                        </p>
                    }
                    buttons={[
                        <button
                            key="action-accept"
                            type="button"
                            className="bk-button"
                            onClick={() => this.submitCookiesForm(true)}>
                            I accept cookies 🍪
                        </button>,
                        <button
                            key="action-reject"
                            type="button"
                            className="bk-button cancel"
                            onClick={() => this.submitCookiesForm(false)}>
                            I reject cookies
                        </button>,
                    ]}
                    dismissable={false}
                />,
            );
            result.push(
                <Header
                    key="header"
                    minimal={
                        isEmpty() ||
                        this.props.history.location.pathname.indexOf('/forms/terms-and-conditions') > -1 ||
                        this.props.history.location.pathname.indexOf('/forms/privacy-policy') > -1
                    }
                    publicView={!!this.props.publicView}
                    hideSearchBar={
                        // hide search bar if user has the rights_management feature flag disabled
                        !this.props.user?.features?.rights_management ||
                        // hide search bar for DnD subscribers who are not Blokur users
                        (isDndSubscriber() && !isBlokurUser()) ||
                        // hide search bar on pages where a search bar already appears in-page,
                        // i.e. browse page (all users) and home page (music users),
                        this.props.history.location.pathname.indexOf('/works') > -1 ||
                        (this.props.user &&
                            this.props.user.hasOwnProperty('source_type') &&
                            this.props.user.source_type === 'M' &&
                            this.props.history.location.pathname === '/')
                    }
                />,
            );
        }
        return result;
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    fetchUser: () => dispatch(fetchUser()),
    pushToast: (toast) => dispatch(pushToast(toast)),
});

SiteHeader.propTypes = {
    user: types.user,
    pushToast: PropTypes.func,
    publicView: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SiteHeader));
